import { Icon } from '@iconify/react';
import { useAvailableActions } from '../../hooks/useAvailableActions';
import { useTranslations } from '../../hooks/use-translations';

const useNavConfig = () => {
  const { canReadSites, canReadEvents, canReadReports, canReadUsers, canReadBoscaAdminReports } = useAvailableActions();
  const { t } = useTranslations();

  const baseNavConfig = [
    {
      title: t('navigation.dashboard'),
      path: '/',
      icon: <Icon icon="mage:dashboard-fill" width="24" height="24" />,
    },
  ];

  const base2NavConfig = [];
  const eventsNavConfig = [];
  const integrationsNavConfig = [];

  if (canReadReports) {
    baseNavConfig.push({
      title: t('navigation.reports'),
      path: '/reports/reporting-hub',
      icon: <Icon icon="mdi:chart-box-outline" width="24" height="24" />,
    });
  }

  if (canReadUsers) {
    base2NavConfig.push({
      title: t('navigation.users'),
      path: '/users',
      icon: <Icon icon="mdi:users" width="24" height="24" />,
    });
  }

  if (canReadSites) {
    base2NavConfig.push({
      title: t('navigation.sites'),
      path: '/sites',
      icon: <Icon icon="fa6-solid:sitemap" width="24" height="24" />,
    });
  }

  if (canReadBoscaAdminReports) {
    base2NavConfig.push({
      title: t('navigation.visitors'),
      path: '/visitors',
      icon: <Icon icon="mdi:account-multiple-check-outline" width="24" height="24" />,
    });
  }

  if (canReadEvents) {
    eventsNavConfig.push({
      title: t('navigation.allEvents'),
      path: '/events/all-events',
      icon: <Icon icon="mdi:events" width="24" height="24" />,
    });
  }

  if (canReadSites) {
    eventsNavConfig.push({
      title: t('navigation.eventGenerator'),
      path: '/event-generator',
      icon: <Icon icon="mdi:auto-fix" width="24" height="24" />,
    });
  }

  // Integrations section (for admins)
  if (canReadBoscaAdminReports) {
    integrationsNavConfig.push({
      title: t('navigation.procoreExplorer'),
      path: '/procore-explorer',
      icon: <Icon icon="mdi:api" width="24" height="24" />,
    });
  }

  return {
    baseNavConfig,
    eventsNavConfig,
    base2NavConfig,
    integrationsNavConfig,
  };
};
export const eventsIcon = <Icon icon="material-symbols:pending-actions" width="24" height="24" />;
export const integrationsIcon = <Icon icon="mdi:connection" width="24" height="24" />;

export default useNavConfig;
